import * as yup from "yup";

export const generalDetailsFormValidation = (): yup.AnyObjectSchema =>
    yup.object({
        personalTitle: yup.string().required(),
        lastName: yup.string().required(),
        firstName: yup.string().required(),
        gender: yup.string().required(),
        maritalStatus: yup.string().required(),
        birthdate: yup.date().birthdate().nullable(),
        language: yup.string().required(),
    });
